<template lang="pug">
.section
  .section-header
    h1 {{ $tc("ui.operators", 2) }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.w-100
              .form-group.col-3.mb-1(v-if="[5].includes(accountType)")
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    i.fa.fa-user-secret
                  b-form-select(v-model="searchType" @change="getOperatorList(true, true)" :disabled="loading" size="sm")
                    option(value=3) {{ $t('ui.master') }}
                    option(value=2) {{ $t('ui.operator') }}
              .form-group.col-3.mb-1
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    i.fa.fa-search
                  DebounceInput(autofocus type="text" v-model="searchID" :placeholder="$t('message.search_by_id')" @enter="getOperatorList(true)" size="sm")
              .form-group.col-3.mb-1
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    span {{ $t('ui.status') }}
                  b-form-select(v-model="accountStatus" size="sm" @change="getOperatorList(true)")
                    option(value="") {{ $t('ui.all') }}
                    option(value="ACTIVE") {{ $t('ui.active') }}
                    option(value="SUSPEND") {{ $t('ui.suspend') }}
                    option(value="CLOSE") {{ $t('ui.close') }}
              .form-group.col-6.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-search"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getOperatorList(true)"
                  variant="primary"
                  size="sm"
                )
              .form-group.col-12(v-if="isAdmin")
                b-button(v-if="isEditAccess" v-b-modal.addOperator type="button" variant="info" size="sm")
                  i.fa.fa-plus
                  span.ml-1 {{ $t("ui.combine.add_account") }}
          .card-body
            .row
              .col-10.mb-1
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)")
              .col-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
              .col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th(width="7%" @click="sortOrder('account_id')")
                          span(:ttile="$t('ui.account_id')") {{ $t('ui.account_id') }}
                          .float-right
                            i(:class="changeSortKey('account_id')")
                        th.text-right(width="8%")
                          span(:title="$t('ui.cash_balance')") {{ $t("ui.cash_balance") }}
                        //-   th.text-right(width="8%")
                        //-     span(:title="$t('ui.security_fund')") {{ $t("ui.security_fund") }}
                        //-   th.text-center(width="12%" @click="sortOrder('payment_setting')")
                        //-     span(:title="$t('ui.payment_setting')") {{ $t("ui.payment_setting") }}
                        //-     .float-right
                        //-       i(:class="changeSortKey('payment_setting')")
                        th(width="10%" @click="sortOrder('full_name')")
                          span(:title="$t('ui.full_name')") {{ $t("ui.full_name") }}
                          .float-right
                            i(:class="changeSortKey('full_name')")
                        th(width="10%" @click="sortOrder('contact_phone')")
                          span(:title="$t('ui.contact_phone')") {{ $t("ui.contact_phone") }}
                          .float-right
                            i(:class="changeSortKey('contact_phone')")
                        th(width="10%" @click="sortOrder('contact_email')")
                          span(:title="$t('ui.contact_email')") {{ $t("ui.contact_email") }}
                          .float-right
                            i(:class="changeSortKey('contact_email')")                          
                        th(width="5%")
                          span(:title="$t('ui.login_ip')") {{ $t("ui.login_ip") }}
                        th.text-center(width="8%")
                          span(:title="$t('ui.status')") {{ $t("ui.status") }}
                        th.text-center(width="14%" v-if="isAdminMaster")
                          span(:title="$t('ui.action')") {{ $t("ui.action") }}
                        th.text-right(width="15%" @click="sortOrder('created_date')")
                          span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                          .float-right
                            i(:class="changeSortKey('created_date')")
                    tbody.clusterize-content
                      tr(v-if="operatorList.length == 0")
                        td(:colspan="isOperator ? 10 : 10").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in operatorList" :class="$helpers.rowClass(item)")
                        td.text-center
                          span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                        td
                          span(v-if="searchType == '2'" :title="item.account_id")
                            template(v-if="isEditAccessSetting")
                              a.text-decoration-none(href="javascript:void(0)" @click="setOperatorID(item)" :title="$t('ui.operator_details')") {{ item.account_id }}
                            template(v-else)
                              | {{ item.account_id }}
                          span(v-else :title="item.account_id") {{ item.account_id }}
                        td.text-right
                          span.font-weight-bold(:title="$n(item.cash_balance, 'currency')") {{ $n(item.cash_balance, 'currency') }}
                        //-   td.text-right
                        //-     span.font-weight-bold(:title="$n(item.security_deposit, 'currency')") {{ $n(item.security_deposit, 'currency') }}
                        //-   td.text-center
                        //-     span(:title="item.payment_setting") {{ item.payment_setting }}
                        td
                          span(:title="item.full_name") {{ item.full_name }}
                        td
                          span(:title="item.contact_phone") {{ item.contact_phone }}
                        td
                          span(:title="item.contact_email") {{ item.contact_email }}                          
                        td
                          span(:title="item.last_login_ip") {{ item.last_login_ip }}
                        td.text-center
                          template(v-if="isEditAccess")
                            b-form-select(v-model="item.status" @change="!isAdminMaster ? null : changedOperatorStatus(item, $event)" size="sm" :disabled="!isAdminMaster")
                              option(value="ACTIVE") {{ $t("ui.active") }}
                              option(v-if="item.status != 'CLOSE'" value="SUSPEND") {{ $t("ui.suspend") }}
                              option(value="CLOSE") {{ $t("ui.close") }}
                              //- option(value="FREEZE") {{ $t("ui.freeze") }}
                          template(v-else)
                            span(:title="item.status" :class="$helpers.badgeClass(item.status)") {{ item.status }}
                        td.text-center
                          template(v-if="isAdminMaster && isEditAccess")
                            span.mr-1
                              a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(href="javascript:void(0)" @click="onEditOperator(item)" :title="$t('ui.edit')")
                            span.mr-1(v-if="item.profile_status.toUpperCase() == 'BLOCK'")
                              a.fas.fa-lock-open.btn.btn-ssm.btn-icon.btn-danger(href="javascript:void(0)" @click="onUnblockOperator(item)" :title="$t('ui.unblock')")
                            span.mr-1
                              a.fa.fa-lock.btn.btn-ssm.btn-icon.btn-warning(href="javascript:void(0)" @click="onResetPassword(item)" :title="$t('ui.reset_password')")
                          template(v-if="searchType == '2' && $helpers.showActionButton('adjustbalanceop')")
                            span.mr-1
                              a.fa.fa-money-bill.btn.btn-ssm.btn-icon.btn-info(href="javascript:void(0)" @click="operatorWalletAdjust(item)" :title="$t('ui.cash_balance')")
                            span.mr-1
                              a.fa.fa-list.btn.btn-ssm.btn-icon.btn-dark(href="javascript:void(0)" @click="operatorAuditLog(item)" :title="$t('ui.audit_log')")
                            span.mr-1
                              a.fa.fa-shopping-cart.btn.btn-ssm.btn-icon.btn-success(href="javascript:void(0)" @click="getDomainList(item)" :title="$t('ui.domain_list')")
                            span.mr-1(v-if="isAccessDailySummaryOperator")
                              a.fa.fa-chart-line.btn.btn-ssm.btn-icon.btn-danger(href="javascript:void(0)" @click="redirectDailySummaryOperator(item)" :title="$t('ui.daily_summary_operator')")
                        td.text-right
                          span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}

      addoperator(@clicked="addOperator" @failed="handleFailed")
      editoperator(ref="editoperator" :item="editSelectedOperator" @clicked="afterEditOperator" @failed="handleFailed")
      resetpassword(ref="resetpassword" :item="editSelectedOperator" @clicked="afterResetPassword" @failed="handleFailed")

      operatorwalletadjust(ref="operatorwalletadjust" :item="editSelectedOperator" @clicked="afterAdjustOperator" @failed="handleFailed")
      operatorauditlog(ref="operatorauditlog" :item="editSelectedOperator")
      domainavailablelist(ref="domainavailablelist" :item="editSelectedOperator")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import addoperator from "@/components/operator/addOperator.vue";
import editoperator from "@/components/operator/editOperator.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import resetpassword from "@/components/operator/resetPassword.vue";

import operatorwalletadjust from "@/components/operator/operatorWalletAdjust.vue";
import operatorauditlog from "@/components/operator/operatorAuditLog.vue";
import domainavailablelist from "@/components/operator/domainAvailableList.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    addoperator,
    editoperator,
    resetpassword,
    operatorwalletadjust,
    operatorauditlog,
    domainavailablelist
  },
  data: () => ({
    loading: false,
    operatorList: [],
    operatorDetail: null,
    currentPage: 1,
    totalRow: 0,
    searchType: "",
    searchID: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    editSelectedOperator: null,
    currOperator: null,
    sortKey: "account_id",
    sortType: "asc",
    filterBy: "account_id",
    accountStatus: ""
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_operator");
    },
    isEditAccessSetting() {
      return this.$helpers.showActionButton("settings");
    },
    isAccessDailySummaryOperator() {
      return this.$helpers.showActionButton("dailysummaryoperator")
    }
  },
  mounted: function() {
    if(this.isOperator) {
      var tt = null;
      var st = null;
      if (this.$route.query.targetTab) { tt = this.$route.query.targetTab; }
      if (this.$route.query.subTab) { st = this.$route.query.subTab; }

      this.$store.dispatch("user/setSelectedOperatorID", this.$store.getters.accountId);
      this.$router.push("/account/settings" + (tt ? "?targetTab=" + tt : "") + (st ? "&subTab=" + st : ""));
    } else {
      if(this.operatorID && this.operatorID.length > 0) {
        this.searchID = this.operatorID
      }

      this.searchType = "2"

      this.getOperatorList(true);
    }
  },
  methods: {
    redirect() {
      this.getOperatorList(true);
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getOperatorList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    setOperatorID: function(e) {
      this.$store.dispatch("user/setSelectedOperatorID", e.account_id);
      this.$store.dispatch("user/setSelectedMemberID", null);
      this.$router.push("/account/settings");
    }, 
    onEditOperator(e) {
      this.editSelectedOperator = e;
      this.$refs.editoperator.$refs.editOperator.show();
    },
    onResetPassword(e) {
      this.editSelectedOperator = e;
      this.$refs.resetpassword.$refs.resetPassword.show();
    },
    redirectDailySummaryOperator: function(info) {
      var json = {
        operator_id: info.account_id
      };

      this.$store.dispatch("user/setReportStatementParam", json);
      this.$router.push("/report/dailySummaryOperator");
    },
    getOperatorList: function(isSearch, clearSearch) {
      let url = config.accountListUrl();

      if (isSearch) this.currentPage = 1;
      if (clearSearch) {
        this.searchID = "";
        this.$store.dispatch("user/setSelectedOperatorID", "");
      }

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        login_id: this.$store.getters.loginId,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize,
        account_status: this.accountStatus
      };

      if (this.searchID.trim() != '')
        json.search_account_id = this.searchID;

      if (this.searchType != '')
        json.search_account_type = this.searchType;

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.operatorList = response.data.dt;
                this.totalRow = this.operatorList.length > 0 ? this.operatorList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getOperatorDetail: function(targetAccId) {
      let url = config.accountAgentDetailUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        source_account_id: this.$store.getters.accountId,
        target_account_id: targetAccId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.operatorDetail = response.data.dt.length > 0 ? response.data.dt[0] : null;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    onUnblockOperator: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.unblock"),
          text: this.$t("message.unblock_operator_confirm", { name: item.account_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmUnblockOperator(item);
          }
        });
    },
    confirmUnblockOperator: function(item) {
      let url = config.accountProfileUnblockUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        login_id: item.account_id,
        audit_by: this.$store.getters.loginId
      };

      this.feedback.success = true;
      // this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          // this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                item.profile_status = "ACTIVE";
                this.$helpers.showDialog(this.$t("ui.unblock_operator"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    changedOperatorStatus: function(operator, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_operator_status_confirm", { name: operator.account_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmOperatorStatus(operator, eventStatus);
          } else {
            this.getOperatorList()
          }
        });
    },
    confirmOperatorStatus: function(operator, status) {
      let url = config.accountStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: operator.account_id,
        new_status: status,
        audit_by: this.$store.getters.loginId
      };

      this.feedback.success = true;
      // this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          // this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
              this.getOperatorList()
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    addOperator: function(account_type) {
      this.searchType = account_type;
      this.searchID = "";
      this.getOperatorList(true);

      this.$helpers.showDialog(this.$t("ui.combine.add_account"), this.$t("message.success"), "success");
    },
    afterEditOperator: function() {
      this.getOperatorList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_account"), this.$t("message.success"), "success");
    },
    afterResetPassword: function() {
      this.getOperatorList();
      this.$helpers.showDialog(this.$t("ui.combine.reset_password"), this.$t("message.success"), "success");
    },
    operatorWalletAdjust(item) {
      this.editSelectedOperator = item;
      this.$refs.operatorwalletadjust.$refs.operatorWalletAdjust.show();
    },
    operatorAuditLog(item) {
      this.editSelectedOperator = item;
      this.$refs.operatorauditlog.$refs.operatorAuditLog.show();
    },
    getDomainList(item) {
      this.editSelectedOperator = item;
      this.$refs.domainavailablelist.$refs.domainAvailableList.show();
    },
    afterAdjustOperator: function() {
      this.getOperatorList();
      this.$helpers.showDialog(this.$t("ui.combine.operator_wallet_adjust"), this.$t("message.success"), "success");
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getOperatorList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      //emit update innertab curr_page = 5
      this.getOperatorList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>